export default __webpack_public_path__ + "static/media/segment-light.6a29ff63.svg";